<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Add Charity</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <router-link to="/admin/charities" class="btn btn-primary" role="button">
                        back
                    </router-link>
                </div>
            </div>
            <form @submit.prevent="createCharity" v-if="charity">
              <div class="row justify-content-md-center">
                <div class="col-12">
                  <div class="row">
                    <div class="col-md-4">
                      <fg-input type="text"
                                v-model="charity.givingName"
                                label="Charity Name"
                                placeholder="Enter Charity Name"
                                v-validate="rules.givingName"
                                data-vv-name="Name"
                                cus-name="Name"
                                :has-errors="errors"
                                :is-fields="fields">
                      </fg-input>
                    </div>
                    <div class="col-md-4">
                      <fg-input type="text"
                                v-model="charity.website"
                                label="Website"
                                placeholder="Enter Website"
                                v-validate="rules.website"
                                data-vv-name="Website"
                                cus-name="Website"
                                :has-errors="errors"
                                :is-fields="fields">
                      </fg-input>
                    </div>
                    <div class="col-md-4">
                      <fg-input type="text"
                                v-model="charity.imageUrl"
                                label="Image URL"
                                placeholder="Enter Image URL"
                                v-validate="rules.website"
                                data-vv-name="Image"
                                cus-name="Image"
                                :has-errors="errors"
                                :is-fields="fields">
                      </fg-input>
                    </div>
                    <div class="col-md-12">
                      <fg-text-area type="text"
                                    v-model="charity.description"
                                    label="Description"
                                    placeholder="Enter Description"
                      >
                      </fg-text-area>
                    </div>
                    <div class="col-3" v-if="status.length">
                      <fg-select
                        v-model="charity.active"
                        label="Status"
                        v-validate="rules.active"
                        data-vv-name="active"
                        cus-name="active"
                        :has-errors="errors"
                        :is-fields="fields"
                        :list="status"
                        selectedKey="id"
                      >
                      </fg-select>
                    </div>
                  </div>
                </div>
                <div class="col-6 text-center">
                  <button type="submit" :disabled="errors.any()" class="btn btn-primary btn-fill btn-block">
                    Add Charity
                  </button>
                </div>
              </div>
                <div class="clearfix"></div>
            </form>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import moment from 'moment'
    export default {
        name: 'CreateCharity',
        created (){
    },
    data () {
        return {
            charity: {
                givingName: '',
                website: '',
                imageUrl: '',
                description: '',
                active: '1'
            },
            active: 1,
            status: [{name:'Select Status'}, {id:"1", name:'Active'}, {id:"0", name:'Inactive'}],
          rules: {
            givingName: {required : true},
            imageUrl: {required: true},
            website: {required: true},
            active: {required: true}
          },
            message: {
                error: false,
                text: ''
            }
        }
    },
    methods: {
        createCharity () {
          console.log("this.Charity : ", this.charity);
          this.$validator.validateAll().then((result) => {
            if(result){
              this.$store.dispatch('ADD_CHARITY', this.charity)
                .then((res) => {
                  console.log("ADD_CHARITY res : ", res);
                  if(res) this.showPopup('Success!', 'Charity is successfully created', 'success', ()=>this.$router.push('/admin/charities'))
                  else this.showPopup('Error!', 'Unable to process.', 'error')
                })
                .catch(err => {
                  this.showPopup('Error!', 'some thing happen wrong', 'error')
                  console.log("ADD_CHARITY API error : ", err);
                })
            }
          })
        },
        showPopup(title, msg, popupType, cb){
            this.$swal( title, msg, popupType
            ).then(res => {
                        cb && cb();
                        return res
                    })
        }
    },
    created() {

    },

    }
</script>

<style>
    .form-control{
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Charities/CreateCharity.vue